import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {createUnionRequest} from "../../../../store/actionCreators/union";

const CreateUnionForm =() => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [unionAvatar, setUnionAvatar] = useState({});

    const changeClubImage = (e) => {
        var reader = new FileReader();
        let fileName = e.target.value.split("\\");
        fileName = fileName[fileName.length - 1].split(".")[0];
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        }
        reader.onload = function () {
            setTimeout(() => {
                setUnionAvatar({name: fileName, data: reader.result});
            }, 500)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    const createUnion = () => {
      dispatch(createUnionRequest(name));
    };
    return (
        <React.Fragment>
            <div className={"currentUnionAvatar"}>
                    <input id={"uploadAvatar"} type="file" accept="image/*" onChange={changeClubImage} />
                    {(unionAvatar.data) ? (<div className={'uploadAvatarPreview'} style={{backgroundImage: 'url(' + (unionAvatar.data) + ')'}}></div>) : ''}
                    <span className="changeAvatar">{t('change')}</span>
                </div>
            <div className="field">
                {t('dialog.createLabel')}
                <label> <input type="text" onChange={ e=>setName(e.target.value) }/></label>
            </div>
            <div className="dialogConfirmBox">
                <button className="primary" onClick={createUnion}>{t('button.create')}</button>
            </div>
        </React.Fragment>
    );
};

export default CreateUnionForm;

